<template>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="py-1" lg="2" md="3" sm="4">
          <v-btn color="primary" class="mb-2" :loading="syncLoading" @click="syncRecords()">{{$t('message.common.sync')}}</v-btn>
        </v-col>
        <v-col cols="12" class="py-1" lg="3" md="4" sm="6">
          <v-select outlined dense hide-details v-model="filterObj.state" :label="$t('message.common.state')" :no-data-text="$t('message.common.noRecords')" :items="listOfProjectState" item-text="title" item-value="value"></v-select>
          <!-- <v-autocomplete outlined dense hide-details v-model="filterObj.state" :label="$t('message.common.state')" :no-data-text="$t('message.common.noRecords')" :items="listOfProjectState" item-text="title" item-value="value"></v-autocomplete> -->
        </v-col>
        <v-col cols="12" class="py-1" lg="3" md="4" sm="6">
          <v-select outlined dense hide-details v-model="filterObj.user_id" :label="$t('message.layout.user')" :no-data-text="$t('message.common.noRecords')" :items="getUsers" item-text="name" item-value="id"></v-select>
          <!-- <v-autocomplete outlined dense hide-details v-model="filterObj.user_id" :label="$t('message.layout.user')" :no-data-text="$t('message.common.noRecords')" :items="getUsers" item-text="name" item-value="id"></v-autocomplete> -->
        </v-col>
      </v-row>
      <v-data-table :headers="headers" :items="listOfProjects" item-key="id" v-model="selected" :must-sort='true' class="elevation-1" dense :loading="loading" :custom-sort="customSort">
        <template v-slot:item.cost="{ item }">
          <td style="border-bottom-width: 0px;">
            <template v-if="item.showEdit">
              <v-text-field v-model.number="item.cost" dense hide-details></v-text-field>
            </template>
            <template v-else>
              {{ item.cost }}
            </template>
          </td>
        </template>
        <template v-slot:item.estimated_hrs="{ item }">
          <td style="border-bottom-width: 0px;">
            <template v-if="item.showEdit">
              <v-text-field v-model="item.estimated_hrs" dense hide-details></v-text-field>
            </template>
            <template v-else>
              {{ item.estimated_hrs }}
            </template>
          </td>
        </template>
        <template v-slot:item.received_payment="{ item }">
          <td style="border-bottom-width: 0px;">
            <template v-if="item.showEdit">
              <v-text-field v-model="item.received_payment" dense hide-details></v-text-field>
              <!-- <v-select :items="['Yes', 'No']" v-model="item.received_payment" dense hide-details></v-select> -->
            </template>
            <template v-else>
              {{ item.received_payment }}
            </template>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <td style="border-bottom-width: 0px;">
            <template v-if="!item.showEdit">
              <v-btn icon small class="pa-0 action--btns ml-1" color="primary" @click="showEditHandler(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small class="pa-0 action--btns ml-1" color="info" @click="$router.push(`${MODULE}/actions/${item.id}`)">
                <v-icon>mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <v-btn icon small class="pa-0 action--btns ml-1" color="success" @click="updateEditHandler(item)">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
              <v-btn icon small class="pa-0 action--btns ml-1" color="error" @click="hideEditHandler(item)">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
          </td>
        </template>
      </v-data-table>
  </v-card-text>
</template>
<script>
import { mapGetters } from 'vuex'
import CONSTANTS from '@/assets/json/constants.json'
import _localStorage from '@/plugins/local_storage'
export default {
  data () {
    return {
      filterObj: {
        state: 2,
        user_id: 0
      },
      activeUser: {},
      listOfProjects: [],
      loading: false,
      selected: [], /*
      paginationList: {
        'itemsPerPageOptions': [10, 25, 50, 100]
      }, */
      total: 0,
      /* pagination: !this.$format.isEmptyObject(this.$store.state.common.PROJECTS_INDEX) ? this.$store.state.common.PROJECTS_INDEX : { sortBy: ['firstname'], itemsPerPage: 25, sortDesc: [false], search: '' }, */
      MODULE: 'projects',
      syncLoading: false,
      filterWatch: false
    }
  },
  computed: {
    ...mapGetters(['getUsers']),
    listOfProjectState () {
      return [{
        value: 1,
        title: this.$t('message.common.all')
      }, {
        value: 2,
        title: this.$t('message.common.active')
      }, {
        value: 3,
        title: this.$t('message.common.completed')
      }]
    },
    headers () {
      return [{
        text: this.$t('message.common.number'),
        value: 'number',
        width: '10%'
      }, {
        text: this.$t('message.common.name'),
        value: 'name',
        width: '20%'
      }, {
        text: this.$t('message.common.responsible'),
        value: 'responsible',
        width: '15%'
      }, {
        text: this.$t('message.common.endDate'),
        value: 'enddate',
        width: '15%'
      }, {
        text: this.$t('message.common.cost'),
        value: 'cost',
        width: '10%'
      }, {
        text: this.$t('message.common.estimatedHours'),
        value: 'estimated_hrs',
        width: '10%'
      }, {
        text: this.$t('message.common.receivedPayment'),
        value: 'received_payment',
        width: '10%'
      }, {
        text: this.$t('message.common.actions'),
        value: 'actions',
        width: '15%'
      }/* , {
        text: this.$t('message.user.group'),
        value: 'group_name',
        width: '20%'
      }, {
        text: this.$t('message.user.isAdmin'),
        value: 'isadmin',
        isBoolean: true,
        sortable: false,
        width: '10%'
      } */]
    }
  },
  created () {
    this.$store.dispatch('getUsers')
  },
  watch: {
    pagination (val) {
      let model = { type: 'PROJECTS_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    },
    filterObj: {
      deep: true,
      handler () {
        if (this.filterWatch) {
          this.$cookie.set(CONSTANTS.PROJECT_LIST_COOKIE, JSON.stringify(this.filterObj))
          this.getListHandler()
        }
      }
    }
  },
  mounted () {
    let getActiveuser = _localStorage.get(process.env.VUE_APP_USER) // this.$cookie.get(process.env.VUE_APP_USER)
    this.activeUser = getActiveuser ? JSON.parse(getActiveuser) : {}
    this.filterObj.user_id = parseInt(this.activeUser.id)
    this.getListHandler()
  },
  methods: {
    customSort (items, index, isDesc) {
      var dateSortArray = ['enddate']
      var sorted = this.$format.customSorting(items, index[0], isDesc[0], dateSortArray, 'DD.MM.YYYY HH:mm:ss')
      return sorted
    },
    getListHandler () {
      let filterObject = this.$cookie.get(CONSTANTS.PROJECT_LIST_COOKIE)
      filterObject = JSON.parse(filterObject)
      if (filterObject) {
        if (!filterObject.state) filterObject.state = 2
        if (!filterObject.user_id) filterObject.user_id = this.activeUser.id
        this.filterWatch = false
        this.filterObj = this.$format.cloneVariable(filterObject)
      }
      this.loading = true
      this.$api.execute('get', `${this.MODULE}/filter?state=${this.filterObj.state}&user_id=${this.filterObj.user_id}`)
        .then((response) => {
          let transformData = { date: { list: ['enddate'], from: 'YYYY-MM-DDTHH:mm:ss', to: 'DD.MM.YYYY' }, number: { list: ['cost', 'estimated_hrs', 'received_payment'], format: 'replaceDotWithComma' } }
          let projects = this.$format.formatListModel(response.data, transformData)
          projects.forEach((project, index) => {
            let obj = this.getUsers.find(x => x.so_userid === project.responsibleid) || {}
            projects[index].responsible = obj.name || ''
            project.showEdit = false
          })
          this.loading = false
          this.listOfProjects = projects
          this.total = projects.length
          this.filterWatch = true
        })
    },
    showEditHandler (item) {
      const index = this.listOfProjects.indexOf(item, 0)
      // this.listOfProjects.find(x => x.id === item.id)
      this.listOfProjects[index].showEdit = true
    },
    hideEditHandler (item) {
      const index = this.listOfProjects.indexOf(item, 0)
      this.listOfProjects[index].showEdit = false
    },
    updateEditHandler (obj) {
      const index = this.listOfProjects.indexOf(obj, 0)
      let item = this.listOfProjects[index]
      let transformData = { date: { list: ['enddate'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' }, number: { list: ['cost', 'estimated_hrs', 'received_payment'], format: 'replaceCommaWithDot' } }
      let model = this.$format.formatModel(item, transformData)
      this.$api.execute('put', `${this.MODULE}/${item.id}`, model).then(response => {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
        this.getListHandler()
      })
    },
    syncRecords () {
      this.syncLoading = true
      this.$api.execute('get', `${this.MODULE}/sync`)
        .then((response) => {
          if (response.status === 200) this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.syncStarted') })
        }).finally(() => {
          this.syncLoading = false
        })
    }
  },
  beforeDestroy () {
  }
}
</script>
